<script>
  import GradientText from "./GradientText.svelte";
  import AccordioItem from "./AccordionItem.svelte";
  import { fade } from "svelte/transition";

  export let groupData = [];
  export let groupName = "";
  export let groupColor = "";
  export let groupGradient = "";

  let isOpen = false;

  const handleOpen = (e) => {
    isOpen = e.detail.isOpen;
  };
</script>

<AccordioItem
  title={groupName}
  bgColor={groupColor}
  bgGradient={groupGradient}
  on:isOpen={handleOpen}
>
  {#if isOpen}
    <div transition:fade class="row-container panel">
      {#each groupData as gd}
        <GradientText gradientTextStyle={gd} />
      {/each}
    </div>
  {/if}
</AccordioItem>

<styel />
